import React from 'react';
import { Box, Dialog } from '@mui/material';
import { PHONE_MEDIA } from '../hooks/useIsPhone';

/**
 * A member's profile picture enlarged in a popup -- the image and nothing else.
 * Backdrop click, Esc or clicking the image closes it.
 *
 * `picture` is `{ url, alt }` (url from utils/profilePicture's profilePictureUrl)
 * or null when closed. Used by MembersListPage and the header's PagePresence.
 */
const ProfilePicturePreview = ({ picture, onClose }) => (
  <Dialog
    open={Boolean(picture)}
    onClose={onClose}
    PaperProps={{ sx: { bgcolor: 'transparent', boxShadow: 'none', m: 2 } }}
  >
    {picture && (
      <Box
        component="img"
        src={picture.url}
        alt={picture.alt}
        onClick={onClose}
        // Stored pictures are 256x256 (users/views.py PROFILE_PICTURE_SIZE): show them at
        // native size so they stay sharp, shrinking only on narrow screens.
        sx={{ display: 'block', width: 'min(256px, 80vw)', height: 'auto', borderRadius: 2, [PHONE_MEDIA]: { mx: 'auto' } }}
      />
    )}
  </Dialog>
);

export default ProfilePicturePreview;
